import { paginatedField } from "@/v2-backoffice-client/components/table"

// Infinite-scroll cache policy for the durable sign-in history. Reuses the
// shared append-on-offset merge, but keys on the typed filter inputs (this
// query carries its filters as top-level input fields rather than the generic
// sort/filters/filterTree shape paginatedField defaults to). Each window/filter
// combination is its own cache entry; successive pages (offset > 0) append.
export const signInCacheFields = {
  getStoredSignInActivities: {
    ...paginatedField(),
    keyArgs: [
      "input",
      [
        "from",
        "to",
        "search",
        "isFailure",
        "location",
        "riskLevel",
        "wasBlocked",
      ],
    ],
  },
}
